/**
 * Created by mateo on 13/12/17.
 */

export class Persona {
    public id: number;
    public nombres: string;
    public apellidoP: string;
    public apellidoS: string;
    public nombresApellidos: string;
    public eMail: string;
    public imageUrl: string;
    public rol: string[];
    public apps: any[];
    public calendar: string;
    public curso: any;
    public codigo: number;

    public acudiente?: string;
    public acudienteTel?: string;

    constructor(json?: any) {
        this.id = json.id;
        this.codigo = json.codigo;
        this.nombres = json.nombres;
        this.apellidoP = json.apellidoP;
        this.apellidoS = json.apellidoS;
        this.nombresApellidos = json.nombresApellidos;
        this.eMail = json.eMail;
        this.rol = typeof json.rol === 'string' ? json.rol.split(',') : typeof json.rol === 'object' ? json.rol : [];
        this.calendar = json.calendar || 'escolar';
        this.imageUrl = json.imageUrl ||  '';
        this.acudiente = json.acudiente || '';
        this.acudienteTel = json.acudienteTel || '';
        this.curso = json.curso || {};
        this.apps = json.apps ||  [];
    }

    public getNombre() {
        return `${this.nombres} ${this.apellidoP} ${this.apellidoS}`;
    }
}
